<template>
  <div>
    <eComplaintsTable v-bind="cProp" @snackbar-msg="mxfSendParent('snackbar-msg', $event)" @go-to-detail="fGoToDetail"  @reload-kpis="fReloadKpis" /> 
  </div>
</template>

<script>
import eComplaintsTable from '@/components/EComplaints/eComplaintsTable.vue'
export default {
  components: { 
    eComplaintsTable 
    },
  methods:{
    // Accede al detalle de un sobre 
    fGoToDetail(complaintInfo){
      this.$emit('go-to-detail-view', complaintInfo)
    },

    // Emit para actualizar kpis en app padre
    fReloadKpis(){
      this.$emit('reload-kpis')
    }
  },
  computed: {
    cProp(){
      return this.$route.query
    }
  }
}
</script>